<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Strony</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/pages">Strony</router-link>
        </li>
        <li class="active">
          <strong>{{ isEditMode ? "Edycja" : "Nowa" }}</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isLayoutOpen = !isLayoutOpen">
            <h5>Układ strony</h5>
            <span class="ibox-toggle">
              <i :class="chevronLayoutClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isLayoutOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Układ strony</label>
                <div class="col-sm-10">
                  <select
                    v-model="pageObj.layout"
                    class="form-control m-b ng-pristine"
                  >
                    <option
                      v-for="(type, index) in pageLayouts"
                      :value="type.value"
                      :key="index"
                    >
                      {{ type.name }}
                    </option>
                  </select>
                  <div v-if="errorsAdminData?.data?.layout" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.layout[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isPlOpen = !isPlOpen">
            <h5>Opis strony [pl]</h5>
            <span class="ibox-toggle">
              <i :class="chevronPlClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isPlOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Adres strony</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.url_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Adres strony"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.url_pl" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.url_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.title_seo_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.keywords_seo_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.description_seo_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Treść - Kolumna 1
                </label>
                <div class="col-sm-10 QuillEditor-box">
                  <Editor
                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                    v-model="pageObj.first_col_content_pl"
                    :init="{
                      toolbar_mode: 'sliding',
                      plugins:
                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                      toolbar:
                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                    }"
                  />
                  <div
                    v-if="errorsAdminData?.data?.first_col_content_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.first_col_content_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Treść - Kolumna 2
                </label>
                <div class="col-sm-10 QuillEditor-box">
                  <Editor
                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                    v-model="pageObj.second_col_content_pl"
                    :init="{
                      toolbar_mode: 'sliding',
                      plugins:
                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                      toolbar:
                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                    }"
                  />
                  <div
                    v-if="errorsAdminData?.data?.second_col_content_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.second_col_content_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isDeOpen = !isDeOpen">
            <h5>Opis strony [de]</h5>
            <span class="ibox-toggle">
              <i :class="chevronDeClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isDeOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Adres strony</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.url_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Adres strony"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.url_de" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.url_de[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.title_seo_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_de[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.keywords_seo_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.description_seo_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Treść - Kolumna 1
                </label>
                <div class="col-sm-10 QuillEditor-box">
                  <Editor
                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                    v-model="pageObj.first_col_content_de"
                    :init="{
                      toolbar_mode: 'sliding',
                      plugins:
                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                      toolbar:
                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                    }"
                  />
                  <div
                    v-if="errorsAdminData?.data?.first_col_content_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.first_col_content_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Treść - Kolumna 2
                </label>
                <div class="col-sm-10 QuillEditor-box">
                  <Editor
                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                    v-model="pageObj.second_col_content_de"
                    :init="{
                      toolbar_mode: 'sliding',
                      plugins:
                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                      toolbar:
                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                    }"
                  />
                  <div
                    v-if="errorsAdminData?.data?.second_col_content_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.second_col_content_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isEnOpen = !isEnOpen">
            <h5>Opis strony [en]</h5>
            <span class="ibox-toggle">
              <i :class="chevronEnClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isEnOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Adres strony</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.url_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Adres strony"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.url_en" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.url_en[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.title_seo_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_en[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.keywords_seo_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.description_seo_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Treść - Kolumna 1
                </label>
                <div class="col-sm-10 QuillEditor-box">
                  <Editor
                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                    v-model="pageObj.first_col_content_en"
                    :init="{
                      toolbar_mode: 'sliding',
                      plugins:
                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                      toolbar:
                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                    }"
                  />
                  <div
                    v-if="errorsAdminData?.data?.first_col_content_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.first_col_content_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Treść - Kolumna 2
                </label>
                <div class="col-sm-10 QuillEditor-box">
                  <Editor
                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                    v-model="pageObj.second_col_content_en"
                    :init="{
                      toolbar_mode: 'sliding',
                      plugins:
                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                      toolbar:
                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                    }"
                  />
                  <div
                    v-if="errorsAdminData?.data?.second_col_content_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.second_col_content_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis strony [de_de]</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Adres strony</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.url_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Adres strony"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.url_cpde" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.url_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.title_seo_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.keywords_seo_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.description_seo_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Treść - Kolumna 1
                </label>
                <div class="col-sm-10 QuillEditor-box">
                  <Editor
                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                    v-model="pageObj.first_col_content_cpde"
                    :init="{
                      toolbar_mode: 'sliding',
                      plugins:
                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                      toolbar:
                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                    }"
                  />
                  <div
                    v-if="errorsAdminData?.data?.first_col_content_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.first_col_content_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Treść - Kolumna 2
                </label>
                <div class="col-sm-10 QuillEditor-box">
                  <Editor
                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                    v-model="pageObj.second_col_content_cpde"
                    :init="{
                      toolbar_mode: 'sliding',
                      plugins:
                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                      toolbar:
                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                    }"
                  />
                  <div
                    v-if="errorsAdminData?.data?.second_col_content_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.second_col_content_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis strony [de_en]</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Adres strony</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.url_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Adres strony"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.url_cpen" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.url_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.title_seo_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.keywords_seo_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="pageObj.description_seo_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Treść - Kolumna 1
                </label>
                <div class="col-sm-10 QuillEditor-box">
                  <Editor
                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                    v-model="pageObj.first_col_content_cpen"
                    :init="{
                      toolbar_mode: 'sliding',
                      plugins:
                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                      toolbar:
                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                    }"
                  />
                  <div
                    v-if="errorsAdminData?.data?.first_col_content_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.first_col_content_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Treść - Kolumna 2
                </label>
                <div class="col-sm-10 QuillEditor-box">
                  <Editor
                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                    v-model="pageObj.second_col_content_cpen"
                    :init="{
                      toolbar_mode: 'sliding',
                      plugins:
                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                      toolbar:
                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                    }"
                  />
                  <div
                    v-if="errorsAdminData?.data?.second_col_content_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.second_col_content_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Podstrony</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <template v-if="isEditMode">
                <button
                  v-if="canAddPage"
                  class="btn btn-sm btn-primary"
                  @click="onSubpageCreate"
                >
                  Dodaj podstronę
                </button>
                <div class="table-responsive m-t-sm">
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th class="drag-column"></th>
                        <th>Adres strony</th>
                        <th>Tytuł</th>
                        <th>Typ</th>
                        <th>Menu</th>
                        <th>Akcje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, index) in subpages"
                        :key="row.pk"
                        class="reorder-row"
                        :class="{
                          'drag-over-row': dragOverSubpagePk === row.pk,
                        }"
                        :draggable="isEditMode && canChangePage"
                        @dragstart="onSubpageDragStart(index, $event)"
                        @dragenter.prevent="onSubpageDragOver(index, $event)"
                        @dragover="onSubpageDragOver(index, $event)"
                        @drop.prevent="onSubpageDrop(index, $event)"
                        @dragend="onSubpageDragEnd"
                      >
                        <td class="drag-column" @click.stop>
                          <span
                            v-if="canChangePage"
                            class="drag-handle"
                            title="Przeciągnij, aby zmienić kolejność"
                          >
                            <i class="fa fa-bars"></i>
                          </span>
                        </td>
                        <td>{{ row.url || row.url_pl || "-" }}</td>
                        <td>{{ row.title_seo || "-" }}</td>
                        <td>{{ row.type || "-" }}</td>
                        <td>{{ row.menu || "-" }}</td>
                        <td>
                          <button
                            v-if="canChangePage"
                            class="btn btn-white btn-xs m-r-xs"
                            @click="onSubpageEdit(row)"
                          >
                            Edytuj
                          </button>
                          <button
                            v-if="canDeletePage"
                            class="btn btn-danger btn-xs"
                            @click="onSubpageDelete(row)"
                          >
                            Usuń
                          </button>
                        </td>
                      </tr>
                      <tr v-if="!subpages.length">
                        <td colspan="6" class="text-center">Brak podstron.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
              <p v-else-if="pageObj.parent">
                Tworzysz podstronę dla strony o ID:
                <strong>{{ pageObj.parent }}</strong>
                .
              </p>
              <p v-else>
                Podstrony można dodawać i edytować po zapisaniu strony.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Konfiguracja strony</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Typ strony</label>
                <div class="col-sm-10">
                  <select
                    v-model="pageObj.type"
                    class="form-control m-b ng-pristine"
                  >
                    <option
                      v-for="(type, index) in pageTypes"
                      :value="type.value"
                      :key="index"
                    >
                      {{ type.name }}
                    </option>
                  </select>
                  <div v-if="errorsAdminData?.data?.type" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.type[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Menu</label>
                <div class="col-sm-10">
                  <select
                    v-model="pageObj.menu"
                    class="form-control m-b ng-pristine"
                  >
                    <option
                      v-for="(type, index) in pageMenu"
                      :value="type.value"
                      :key="index"
                    >
                      {{ type.name }}
                    </option>
                  </select>
                  <div v-if="errorsAdminData?.data?.menu" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.menu[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="pageObj.in_sitemap"
                        name="is_published"
                        type="checkbox"
                      />
                      <span>Publikuj w mapie serwisu</span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Data publikacji</label>
                <div class="col-sm-10">
                  <VueDatePicker :format="format" v-model="publication_date" />
                  <div
                    v-if="errorsAdminData?.data?.publication_date"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.publication_date[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="hr-line-dashed"></div>

              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <router-link class="btn btn-white" to="/pages">
                    Anuluj
                  </router-link>
                  <button
                    v-if="canSubmitPage"
                    @click="submitPage"
                    class="btn btn-primary"
                  >
                    {{ isEditMode ? "Zapisz" : "Dodaj" }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Editor from "@tinymce/tinymce-vue";
import { hasPermission } from "../../permissions";
import { pagePermissionsConst } from "../../constants/pageConstants";

export default {
  name: "PagesCreate",
  mixins: [],
  components: {
    Editor,
  },
  props: {},

  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const pageObj = ref({
      url: "",
      description: "",
      subpages: [],
    });

    const countryList = ref([
      { name: "Polska", value: "PL" },
      { name: "Niemcy", value: "DE" },
    ]);

    const modules = ref({
      syntax: true,
      toolbar: [
        [{ header: "1" }, { header: "2" }, { font: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: [] }],
        ["bold", "italic", "underline"],
        ["link"],
        ["code-block"],
      ],
    });

    const errorsAdminData = ref();
    const publication_date = ref();
    const pageTypes = ref([]);
    const pageLayouts = ref([]);
    const pageMenu = ref([]);
    const showErrors = ref(false);
    const isLayoutOpen = ref(true);
    const isPlOpen = ref(true);
    const isDeOpen = ref(true);
    const isEnOpen = ref(true);
    const draggedSubpagePk = ref(null);
    const dragOverSubpagePk = ref(null);

    const isEditMode = computed(() => Boolean(route.params.pk));
    // Subpages are pages too, so the nested table uses the same permissions.
    const canAddPage = computed(() => hasPermission(pagePermissionsConst.add));
    const canChangePage = computed(() =>
      hasPermission(pagePermissionsConst.update)
    );
    const canDeletePage = computed(() =>
      hasPermission(pagePermissionsConst.delete)
    );
    // The same form creates and edits a page.
    const canSubmitPage = computed(() =>
      isEditMode.value ? canChangePage.value : canAddPage.value
    );
    const subpages = computed(() => pageObj.value.subpages || []);
    const createPagesData = computed(() => store.getters.getCreatePagesData);
    const pageData = computed(() => store.getters.getPageData);
    const updatePagesData = computed(() => store.getters.getUpdatePagesData);
    const pageTypesData = computed(() => store.getters.getPageTypesData);
    const pageLayoutsData = computed(() => store.getters.getPageLayoutsData);
    const pageMenuData = computed(() => store.getters.getPageMenuData);
    const chevronLayoutClass = computed(() =>
      isLayoutOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronPlClass = computed(() =>
      isPlOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeClass = computed(() =>
      isDeOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronEnClass = computed(() =>
      isEnOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const format = (date) => {
      const normalizedDate = Array.isArray(date) ? date[0] : date;
      if (!(normalizedDate instanceof Date)) {
        return "";
      }

      let day, month, year, hours, minutes, seconds;
      day = normalizedDate.getDate();
      month = ("0" + (normalizedDate.getMonth() + 1)).slice(-2);
      year = normalizedDate.getFullYear();
      minutes = ("0" + normalizedDate.getMinutes()).slice(-2);
      seconds = ("0" + normalizedDate.getSeconds()).slice(-2);
      hours = normalizedDate.getHours();

      return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    };

    const parseCustomDate = (dateStr) => {
      const [date, time] = dateStr.split(" ");
      const [day, month, year] = date.split(".");
      const [hour, minute, second] = time.split(":");
      const formattedDate = `${year}-${month}-${day}T${hour}:${minute}:${second}`;
      return new Date(formattedDate);
    };

    const submitPage = () => {
      if (!canSubmitPage.value) {
        return;
      }
      showErrors.value = true;
      pageObj.value.publication_date = format(publication_date.value) || null;

      if (isEditMode.value) {
        store.dispatch("updatePages", pageObj.value);
        return;
      }

      store.dispatch("createPages", pageObj.value);
    };

    const onSubpageCreate = () => {
      if (!canAddPage.value || !pageObj.value?.pk) {
        return;
      }

      router.push({
        path: "/pages/create",
        query: {
          parent: pageObj.value.pk,
        },
      });
    };

    const onSubpageEdit = (row) => {
      if (!canChangePage.value || !row?.pk) {
        return;
      }

      router.push({
        name: "PagesEdit",
        params: { pk: row.pk },
      });
    };

    const onSubpageDelete = (row) => {
      if (!canDeletePage.value || !row?.pk) {
        return;
      }
      if (!window.confirm(`Czy na pewno chcesz usunąć "${row.title_seo}"?`)) {
        return;
      }

      store.dispatch("deletePages", { pk: row.pk });
      pageObj.value.subpages = subpages.value.filter(
        (subpage) => subpage.pk !== row.pk
      );
    };

    const onSubpageDragStart = (index, event) => {
      const row = subpages.value[index];
      if (!row) {
        event.preventDefault();
        return;
      }

      draggedSubpagePk.value = row.pk;
      if (event?.dataTransfer) {
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.dropEffect = "move";
        event.dataTransfer.setData("text/plain", String(row.pk));
      }
    };

    const onSubpageDragOver = (index, event) => {
      const row = subpages.value[index];
      if (!row) {
        return;
      }

      event.preventDefault();
      if (event?.dataTransfer) {
        event.dataTransfer.dropEffect = "move";
      }
      dragOverSubpagePk.value = row.pk;
    };

    const onSubpageDragEnd = () => {
      draggedSubpagePk.value = null;
      dragOverSubpagePk.value = null;
    };

    const onSubpageDrop = async (index, event) => {
      event.preventDefault();
      const targetRow = subpages.value[index];
      if (
        !canChangePage.value ||
        !draggedSubpagePk.value ||
        !targetRow ||
        draggedSubpagePk.value === targetRow.pk
      ) {
        onSubpageDragEnd();
        return;
      }

      const fromIndex = subpages.value.findIndex(
        (row) => row.pk === draggedSubpagePk.value
      );
      const toIndex = index;
      if (fromIndex < 0 || toIndex < 0) {
        onSubpageDragEnd();
        return;
      }

      const reorderedSubpages = [...subpages.value];
      const [movedSubpage] = reorderedSubpages.splice(fromIndex, 1);
      reorderedSubpages.splice(toIndex, 0, movedSubpage);
      pageObj.value.subpages = reorderedSubpages;

      onSubpageDragEnd();
      try {
        await store.dispatch("reorderPages", {
          pk: movedSubpage.pk,
          subpage_position: toIndex,
        });
        await store.dispatch("getPage", { pk: route.params.pk });
        store.dispatch("showToaster", {
          type: "success",
          content: "Kolejność podstron została zaktualizowana",
        });
      } catch (e) {
        await store.dispatch("getPage", { pk: route.params.pk });
        store.dispatch("showToaster", {
          type: "error",
          content: "Nie udało się zmienić kolejności podstron",
        });
      }
    };

    store.dispatch("getPageTypes");
    store.dispatch("getPageLayouts");
    store.dispatch("getPageMenu");

    if (route.query.parent && !isEditMode.value) {
      const parentPk = Number(route.query.parent);
      if (!Number.isNaN(parentPk)) {
        pageObj.value.parent = parentPk;
      }
    }

    if (isEditMode.value) {
      store.dispatch("getPage", { pk: route.params.pk });
    }

    watch(
      () => createPagesData.value,
      function (newValue) {
        if (isEditMode.value || !newValue?.status) {
          return;
        }

        if (newValue.status === 201) {
          const redirectTarget = pageObj.value.parent
            ? { name: "PagesEdit", params: { pk: pageObj.value.parent } }
            : { name: "PagesList", path: "/pages" };

          router.push(redirectTarget).then(() => {
            store.dispatch("showToaster", {
              type: "success",
              content: "Strona została dodana",
            });
          });
        } else {
          const msg = [];
          for (const [key, value] of Object.entries(newValue.data || {})) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    watch(
      () => pageData.value,
      function (newValue) {
        if (!isEditMode.value || !newValue?.data) {
          return;
        }

        pageObj.value = { ...newValue.data };
        if (newValue.data.publication_date) {
          publication_date.value = parseCustomDate(
            newValue.data.publication_date
          );
        } else {
          publication_date.value = "";
        }
      }
    );

    watch(
      () => updatePagesData.value,
      function (newValue) {
        if (!newValue?.status || !isEditMode.value) {
          return;
        }

        if (newValue.status === 200) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
          router.push({ name: "PagesList", path: "/pages" });
        } else {
          const msg = [];
          for (const [key, value] of Object.entries(newValue.data || {})) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    watch(
      () => pageTypesData.value,
      function (newValue) {
        pageTypes.value = [];
        newValue.data?.forEach((element) => {
          pageTypes.value.push({
            name: element[1],
            value: element[0],
          });
        });
      }
    );

    watch(
      () => pageLayoutsData.value,
      function (newValue) {
        pageLayouts.value = [];
        newValue.data?.forEach((element) => {
          pageLayouts.value.push({
            name: element[1],
            value: element[0],
          });
        });
      }
    );

    watch(
      () => pageMenuData.value,
      function (newValue) {
        pageMenu.value = [];
        newValue.data?.forEach((element) => {
          pageMenu.value.push({
            name: element[1],
            value: element[0],
          });
        });
      }
    );

    return {
      countryList,
      pageObj,
      errorsAdminData,
      showErrors,
      submitPage,
      pageTypes,
      pageLayouts,
      pageMenu,
      format,
      modules,
      publication_date,
      isEditMode,
      canAddPage,
      canChangePage,
      canDeletePage,
      canSubmitPage,
      subpages,
      onSubpageCreate,
      onSubpageEdit,
      onSubpageDelete,
      dragOverSubpagePk,
      onSubpageDragStart,
      onSubpageDragOver,
      onSubpageDragEnd,
      onSubpageDrop,
      isLayoutOpen,
      isPlOpen,
      isDeOpen,
      isEnOpen,
      chevronLayoutClass,
      chevronPlClass,
      chevronDeClass,
      chevronEnClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}

.ibox-toggle:hover {
  color: #333;
}

.reorder-row {
  cursor: move;
}

.drag-column {
  width: 36px;
  text-align: center;
}

.drag-handle {
  color: #999;
}

.drag-over-row td {
  border-top: 2px solid #1ab394 !important;
}
</style>
